import * as actionTypes from "./actionTypes";
import * as marketingService from "./service";
import { applyFilter } from "../../utils/general";

const log = require("loglevel").getLogger("MarketingActions");
log.setLevel("error");

export const loadMarketingById = (id) => {
  return async (dispatch) => {
    log.debug("MarketingActions -> loadOpportunityById -> Enter");

    const marketing = await marketingService.loadMarketingById(id);

    await dispatch({
      type: actionTypes.MARKETING_LOADED,
      data: marketing,
    });
  };
};

export const loadMarketing = (selectedFilters, forceReload) => {
  return async (dispatch) => {
    log.debug("MarketingActions -> loadMarketing -> Enter");

    const result = await marketingService.loadMarketing(
      selectedFilters,
      forceReload
    );

    const records = result?.data?.records ?? [];
    const lastUpdated = result?.data?.lastUpdated;

    let filteredMarketing = records;

    selectedFilters?.forEach((filter) => {
      filteredMarketing = applyFilter(filteredMarketing, filter);
    });

    await dispatch({
      type: actionTypes.MARKETINGS_LOADED,
      data: filteredMarketing,
      lastUpdated,
    });
  };
};
